export default __webpack_public_path__ + "static/cellRendering-a3b0bde8a5b0230a6cef5742fee89f4a.gif";